export var EnvType;
(function (EnvType) {
    EnvType["Worker"] = "WORKER";
    EnvType["Frame"] = "FRAME";
})(EnvType || (EnvType = {}));
export const classMetadataKey = Symbol('CLASS_METADATA_KEY');
//# sourceMappingURL=common.js.map